import { Component, OnInit } from '@angular/core';
import { CmsService } from 'src/app/services/api/cms.service';

@Component({
  selector: 'app-approveartwork',
  templateUrl: './approveartwork.component.html',
  styleUrls: ['./approveartwork.component.scss']
})
export class ApproveartworkComponent implements OnInit {
  onClose: any;
  onAgree: any;

  constructor(
    public cms: CmsService
  ) { }

  ngOnInit() {
    if(!this.cms.cms['block_42']){
      this.cms.getBlock(42, true, false).then(f => {
      });
    }
  }

  closeModal(){
    this.onClose();
  }

  approveArtwork(){
    this.onAgree();
  }

}
